export default __webpack_public_path__ + "static/SRUS P149 - Product Specifications & Technical Data-f845c75cd5ca0fedd39a5d91a375d06f.pdf";